import { Component, inject, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { AccountSessionExpiredService } from '@app/core/libraries';
import { ProfileFacade } from '@app/store/profile';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { SidebarComponent } from './sidebar/sidebar.component';

@Component({
    selector: 'app-shell',
    templateUrl: './shell.component.html',
    styleUrls: ['./shell.component.css'],
    imports: [RouterModule, TranslatePipe, HeaderComponent, SidebarComponent, FooterComponent],
    providers: [AccountSessionExpiredService],
})
export class ShellComponent {
    readonly accountSessionExpiredService = inject(AccountSessionExpiredService);
    private readonly profileFacade = inject(ProfileFacade);

    /** The sidebar drawer below lg; picking a page closes it. */
    protected readonly menuOpen = signal(false);

    constructor() {
        this.profileFacade.getProfile();
    }
}
